import {
  jb_listing_grid_css_default
} from "./chunk.2ZQHVJMZ.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  ChangesBackgroundColor
} from "./chunk.XYH4LHGJ.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  o
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-listing-grid/jb-listing-grid.ts
var JbListingGrid = class extends ChangesBackgroundColor(Spaceable(i)) {
  firstUpdated() {
    this.style.setProperty("--_column-count", this.columns.toString());
    this._gridItems.forEach((gridItem) => {
      if (gridItem instanceof HTMLElement) {
        gridItem.setAttribute("role", "listitem");
      }
    });
  }
  _getContentSpacingProperties() {
    const gridCols = this.variant === "wide" || this.columns === 3 ? 12 : 10;
    return {
      colsMdUp: gridCols,
      horizontal: this.variant ?? void 0,
      type: this.headline ? "list" : "list-without-heading"
    };
  }
  _tracking(e3) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e3, {
      component_name: "listing"
    });
    if (jbTrackingEvent) this.dispatchEvent(jbTrackingEvent);
  }
  render() {
    return b`
      <!-- The name repeats the headline rather than referencing it: aria-labelledby pointing at a
           jb-heading resolves to an empty name, because the text it renders is slotted into its
           shadow root. -->
      <section
        aria-label=${this.headline || A}
        class=${e2({ "listing-grid": true, [`cols${this.columns}`]: true, wide: this.variant === "wide" })}
      >
        ${this.headline ? b`<jb-heading class="title">${this.headline}</jb-heading>` : A}
        <jb-heading-context offset=${this.headline ? 1 : 0}>
          <div
            class="columns"
            role="list"
          >
            <slot @jb-link:clicked=${this._tracking}></slot>
          </div>
        </jb-heading-context>
      </section>
    `;
  }
};
JbListingGrid.styles = [reset_css_default, jb_listing_grid_css_default];
__decorateClass([
  n({ type: Number })
], JbListingGrid.prototype, "columns", 2);
__decorateClass([
  n({ reflect: true })
], JbListingGrid.prototype, "headline", 2);
__decorateClass([
  n()
], JbListingGrid.prototype, "variant", 2);
__decorateClass([
  e("slot")
], JbListingGrid.prototype, "_grid", 2);
__decorateClass([
  o()
], JbListingGrid.prototype, "_gridItems", 2);
JbListingGrid = __decorateClass([
  customElement("jb-listing-grid")
], JbListingGrid);

export {
  JbListingGrid
};
